<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
</script>

<template>
    <StackLayout direction="column" :gap="8" class="flex-auto dashboard-content">
        <slot />
    </StackLayout>
</template>

<style scoped lang="scss">
.dashboard-content {
    overflow-y: auto;
    padding: 8px;
}
</style>
